import React from "react";
import PropTypes from "prop-types";
import { Chip } from "@mui/material";
import { BsClockFill } from "react-icons/bs";
import Tooltip from "./Tooltip";

const propTypes = {
  extensions: PropTypes.array.isRequired,
  originalDueDate: PropTypes.string.isRequired,
};

export const ExtensionsTooltip = (props) => {
  const extensionsTooltip = props.extensions ? (
    <>
      <b>You requested {props.extensions.length} extensions for this care plan requirement.</b>
      <br />
      Original Due Date: {props.originalDueDate}
    </>
  ) : null;

  return (
    <Tooltip
      content={extensionsTooltip}
      tooltip={
        <Chip
          mt={1.5}
          ml={1}
          avatar={<BsClockFill className="badge-icon" />}
          className="extension"
          label={"Extension"}
          variant="outlined"
        />
      }
    />
  );
};
ExtensionsTooltip.prototype = propTypes;
export default ExtensionsTooltip;
